




























import { Component, Prop } from "vue-property-decorator";
import { Mixins } from "vue-mixin-decorator";
import ComponentVue from "@/app/core/window/ComponentVue";
import { StoreUseData } from "@/@types/store";

@Component
export default class ChatOptionSelector extends Mixins<ComponentVue>(
  ComponentVue
) {
  @Prop({ type: String, required: true })
  private title!: string;

  @Prop({ type: Array, required: true })
  private list!: StoreUseData<any>[];

  @Prop({ type: Number, required: true })
  private max!: number;

  @Prop({ type: String })
  private value!: string;

  public get localValue(): string {
    return this.value;
  }

  public set localValue(value: string) {
    this.input(value);
  }

  private input(value: string) {
    this.$emit("input", value);
  }

  private bt = "chat-window.options.";

  /**
   * 現在のページ番号
   */
  private get page(): number {
    const index = this.list.findIndex(item => item.id === this.localValue);
    return Math.floor(index / this.max) + 1;
  }

  /**
   * ページ数
   */
  private get pageMax(): number {
    return Math.ceil(this.list.length / this.max);
  }

  private get pagedList(): StoreUseData<any>[] {
    const firstIdx = (this.page - 1) * this.max;
    const endIdx = firstIdx + this.max;
    return this.list.slice(firstIdx, endIdx);
  }
}
